export default {
    getMessageDetails(message) {
        return [
            'LaunchTimeStamp',
            'ResponsysID',
            'ListID',
            'LaunchID',
            'ProgramID'
        ]
            .filter(property => message[property])
            .map(property => ({
                header: property,
                value: message[property]
            }))
    }
}
